import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginGuard } from './login/login.guard';
import { LoginComponent } from './login/login.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { AuthGuard } from './auth/auth.guard';
import { CommitteeCalendarComponent } from './committee-calendar/committee-calendar.component';
import { CommitteeApprovalDashboardComponent } from './committee-approval-dashboard/committee-approval-dashboard.component';
import { DispositionsComponent } from './dispositions/dispositions.component';
import {
  CompanyEventsCalendarComponent
} from "./company-events/company-events-calendar/company-events-calendar.component";
import {CompanyEventsComponent} from "./company-events/company-events.component";
import {CompanyEventsListComponent} from "./company-events/company-events-list/company-events-list.component";
import {FundsListComponent} from "./funds/funds-list.component";
import {FundComponent} from "./funds/fund/fund.component";
import {SyndicationsPipelineModule} from "./syndications-pipeline/syndications-pipeline.module";
import {SyndicationsPipelineComponent} from "./syndications-pipeline/syndications-pipeline.component";

import {EquityInstallmentComponent} from "./equity-installment/equity-installment.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import {ContactsComponent} from "./contacts/contacts.component";
import {ContactsListComponent} from "./contacts/contacts-list.component";
import {DueDiligenceComponent} from "./due-diligence/due-diligence.component";
import {PipelinesComponent} from "./pipelines/pipelines.component";
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DealsHomeComponent } from './deals/deals-home/deals-home.component';
import { DealsCommitteeDashboardComponent } from './deals/deals-committee-dashboard/deals-committee-dashboard.component';
import { DealsClosingDashboardComponent } from './deals/deals-closing-dashboard/deals-closing-dashboard.component';
import { DealDispositionsComponent } from './deals/deal-dispositions/deal-dispositions.component';
import { DealTermsComponent } from './deals/deal-terms/deal-terms.component';



const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
    data: { title: 'Login' },
  },
  {
    path: '',
    component: SideNavComponent,
    children: [
      {
        path: 'main',
        component: CommitteeCalendarComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { title: 'Committee Calendar' },
      },
      {
        path: 'dashboards/:id',
        component: CommitteeApprovalDashboardComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { title: 'Committee Approval Dashboard' },
      },
      {
        path: 'dispositions',
        component: DispositionsComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: { title: 'Dispositions' },
      },
      {
        path: 'pipeline',
        component: PipelinesComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Pipelines"}
      },
      {
        path: 'pipeline/:filter',
        component: PipelinesComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Pipelines"}
      },
      {
        path: "company_events/calendar",
        component: CompanyEventsCalendarComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Company Events"}
      },
      {
        path: "company_events/list",
        component: CompanyEventsListComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Company Events"}
      },
      {
        path: "company_events/:id",
        component: CompanyEventsComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Company Events"}
      },
      { path: 'company_events/edit/:id', redirectTo: 'company_events/:id', pathMatch: 'full'},
      { path: 'company_events/view/:id', redirectTo: 'company_events/:id', pathMatch: 'full'},
      {
        path: 'credit_outlets',
        component: FundsListComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Credit Outlets"}
      },
      {
        path: 'syndications',
        component: SyndicationsPipelineComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Syndications Pipeline"}
      },
      {
        path:'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Dashboard"}
      },
      {
        path: 'contacts/:subroute/:id',
        component: ContactsComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Contacts"}
      },
      { path: 'contacts/:subroute/view/:id', redirectTo: 'contacts/:subroute/:id', pathMatch: 'full'},
      {
        path: 'diligence',
        component: DueDiligenceComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {title: "Diligence"}
      },
      {
        path: 'deal',
        children: [
          {
            path: ':id',
            component: DealsHomeComponent,
            data: { tab: 'deal', icon: 'home' },
            pathMatch: 'full',
          },
          {
            path: 'dashboard/:id',
            component: DealsCommitteeDashboardComponent,
            data: { tab: 'committees', icon: 'event_available' },
          },
          {
            path: 'closing/:id',
            component: DealsClosingDashboardComponent,
            data: { tab: 'closing', icon: 'close_fullscreen' },
          },
          {
            path: 'dispositions/:id',
            component: DealDispositionsComponent,
            data: { tab: 'dispositions', icon: 'exit_to_app' },
          },
          {
            path: 'terms/:id',
            component: DealTermsComponent,
            data: { tab: 'terms', icon: 'list_alt' },
          },
          {
            path: 'equity_installments/:id',
            component: EquityInstallmentComponent,
            data: { tab: 'installments', icon: 'assignment_returned' },
          },
          {
            path: '',
            component: NotFoundComponent,
            pathMatch: 'full',
          },
          {
            path: '**',
            component: NotFoundComponent,
            pathMatch: 'full',
          },
        ],
      },
      // {
      //   path: 'fund/:id',
      //   component: FundComponent,
      //   canActivate: [AuthGuard],
      //   canActivateChild: [AuthGuard],
      //   data: {title: "Fund"}
      // },

      { path: '', redirectTo: 'main', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
